<template>
  <div class="m-wrapper">
    <notifications></notifications>
    <header class="m-topbar">
      <button v-if="showBack" class="m-topbar__icon" @click="goBack" :aria-label="$t('mobile.back')">
        <i class="material-icons">arrow_back</i>
      </button>
      <span class="m-topbar__title">{{ title }}</span>
      <router-link to="/app/dashboard" class="m-topbar__icon" :aria-label="$t('mobile.desktopView')">
        <i class="material-icons">desktop_windows</i>
      </router-link>
    </header>

    <main class="m-content">
      <router-view></router-view>
    </main>

    <nav class="m-tabbar">
      <router-link v-for="tab in visibleTabs" :key="tab.path" :to="tab.path" class="m-tabbar__item" active-class="m-tabbar__item--active">
        <i class="material-icons">{{ tab.icon }}</i>
        <span>{{ $t(tab.label) }}</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { isAdmin, canView } from "@/mixins/auth";

export default {
  name: "MobileLayout",
  data() {
    return {
      // menu: derselbe Schluessel wie am Desktop, damit Rechte nicht doppelt gepflegt werden.
      // menu === null: immer sichtbar.
      tabs: [
        { path: "/m/lieferplan", icon: "local_shipping", label: "layout.shippingPlans", menu: "ShippingPlans" },
        { path: "/m/retoure", icon: "assignment_return", label: "returns.title", menu: "Returns" },
        // WMS-Tab fuer jeden mit irgendeinem WMS-Recht (Kachelseite filtert selbst, Trello 21.08.)
        { path: "/m/lager", icon: "warehouse", label: "layout.wms.wms", menu: ["Warehouses", "Inventories", "StorageLocations"] },
        { path: "/m/suche", icon: "search", label: "mobile.search", menu: null },
        { path: "/m/zahlen", icon: "bar_chart", label: "mobile.figures", menu: "Dashboard" },
      ],
    };
  },
  computed: {
    visibleTabs() {
      // canView() kennt keinen Admin-Kurzschluss (siehe mixins/auth.js) — deshalb hier wie in
      // DashboardLayout.vue explizit gegen isAdmin() pruefen, sonst sieht ein Administrator
      // ohne einzeln vergebene Menuerechte gar nichts.
      return this.tabs.filter((t) => t.menu === null || isAdmin() || (Array.isArray(t.menu) ? t.menu.some((m) => canView(m)) : canView(t.menu)));
    },
    title() {
      return this.$route.meta && this.$route.meta.title ? this.$t(this.$route.meta.title) : "CS-Trading";
    },
    showBack() {
      return !!(this.$route.meta && this.$route.meta.mobileBack);
    },
  },
  methods: {
    // Bewusst nicht $router.back(): die Browser-Historie fuehrt dorthin, wo der Nutzer vorher war
    // (z.B. Lieferplan), nicht zur uebergeordneten Seite. mobileBack traegt deshalb das Ziel.
    goBack() {
      const target = this.$route.meta && this.$route.meta.mobileBack;
      if (typeof target === "string") {
        if (this.$route.path !== target) this.$router.push(target).catch(() => {});
        return;
      }
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
$bar: 56px;
$tabbar: 60px;

.m-wrapper {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f4f4f4;
  color: #212121;

  // Das Material-Dashboard-Theme faerbt jeden Link in der Akzentfarbe (lila). Im Mobilbereich
  // sind Karten und Tabs Links — die sollen ihre eigene Farbe behalten, nicht die des Themes.
  a,
  a:hover,
  a:focus {
    color: inherit;
    text-decoration: none;
  }
}

.m-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: $bar;
  background: #7f915a;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
  z-index: 20;

  &__title {
    font-size: 17px;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
  }

  &__icon {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: none;
    border: 0;
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}

.m-content {
  padding: $bar 0 $tabbar;
  min-height: 100vh;
  min-height: 100dvh;
}

.m-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: $tabbar;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  z-index: 20;
  padding-bottom: env(safe-area-inset-bottom);

  .m-tabbar__item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    color: #9e9e9e;
    text-decoration: none;
    font-size: 11px;

    i {
      font-size: 22px;
    }

    &.m-tabbar__item--active,
    &.m-tabbar__item--active:hover {
      color: #7f915a;
    }
  }
}
</style>
